// extracted by mini-css-extract-plugin
export default {"statusCell":"ResultsTable_statusCell__A3R+9"};